import JM from '@/assets/js/JMan'

const uri = "/api/v0";

const jman = new JM.JMan({uri});

export {
	jman,
};



// WEBPACK FOOTER //
// ./src/services/jman/jman.js